import { lzDateAddDays, lzDateAddMonths, lzDateAddYears } from "../services/LzMoment";
import { lzIsArray } from "../services/LzType";
import GatewaySubscriptionDetailsAuthnetModel from "./gateway-subscription-details-authnet";
import GatewaySubscriptionDetailsPaypalModel from "./gateway-subscription-details-paypal";

export default class GatewaySubscriptionModel {

    static GATEWAY_AUTHORIZE_NET = 'Authorize.NET';
    static GATEWAY_PAYPAL = 'PayPal';

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.id = model.id ? +model.id : 0;
        this.gateway = GatewaySubscriptionModel.getGateway(model.gateway);
        this.invoice_no = model.invoice_no ? model.invoice_no : '';
        this.details = GatewaySubscriptionModel.getDetailsObject(this.gateway, model.details);
        this.created_at = model.created_at ? model.created_at : '';
        this.updated_at = model.updated_at ? model.updated_at : '';
    }

    evaluateEndedAt() {
        if (this.started_at && this.started_at !== '') {
            this.ended_at = this.is_monthly ? lzDateAddMonths(this.started_at, 1) : lzDateAddYears(this.started_at, 1);
            this.ended_at = lzDateAddDays(this.ended_at, -1);
        } else {
            this.ended_at = '';
        }
    }

    static parseArray(data) {
        if (!lzIsArray(data)) {
            return [];
        }

        const out = [];
        for (const item of data) {
            out.push(new GatewaySubscriptionModel(item));
        }

        return out;
    }

    static getGateway(gateway) {
        return gateway && gateway !== '' ? gateway : GatewaySubscriptionModel.GATEWAY_AUTHORIZE_NET;
    }

    static getDetailsObject(gateway, details) {
        // Set the details based on the gateway
        if (gateway == GatewaySubscriptionModel.GATEWAY_AUTHORIZE_NET) {
            return new GatewaySubscriptionDetailsAuthnetModel(details);
        }

        if (gateway == GatewaySubscriptionModel.GATEWAY_PAYPAL) {
            return new GatewaySubscriptionDetailsPaypalModel(details);
        }

        return null;
    }

}
